import { render, staticRenderFns } from "./index.vue?vue&type=template&id=de1f7a16&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de1f7a16",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/test-cdp-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('de1f7a16')) {
      api.createRecord('de1f7a16', component.options)
    } else {
      api.reload('de1f7a16', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=de1f7a16&scoped=true", function () {
      api.rerender('de1f7a16', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/VipCustomers/index.vue"
export default component.exports